/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { Button } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/content/edit/addanswer/addanswer_styles';



/* ========== ~~~~~~~~~~ EMBED : EDIT : ADD ~~~~~~~~~~ ========== */
class AddAnswer extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }
	handleClick() {
		this.props.addOption(this.props.contentId)
	}
    render() {
        if (this.props.numberOfOptions === 4) { return null; }
        return(
            <Button type={`custom`} handleClick={this.handleClick} variant={`system`} name={`addanswer`} text={`+ Add Answer`} klass={`${this.props.classes.addanswer} editorelement`} />
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(AddAnswer);
